export enum DirectoryPhysicianType {
  PHYSICIAN = 'physician',
  RESIDENT = 'resident',
}

export enum DirectoryPhysicianStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  LIMITED = 'limited',
  SUSPENDED = 'suspended',
  RESIDENT = 'resident',
}

export enum DirectoryPhysicianSpecialty {
  ADOLESCENT_MEDICINE = 'adolescentMedicine',
  ANATOMICAL_PATHOLOGY = 'anatomicalPathology',
  ANESTHESIOLOGY = 'anesthesiology',
  CARDIAC_SURGERY = 'cardiacSurgery',
  CARDIO_VASCULAR_AND_THORACIC_SURGERY = 'cardioVascularAndThoracicSurgery',
  CARDIOLOGY = 'cardiology',
  CHILD_AND_ADOLESCENT_PSYCHIATRY = 'childAndAdolescentPsychiatry',
  CLINICAL_IMMUNOLOGY_AND_ALLERGY = 'clinicalImmunologyAndAllergy',
  COLORECTAL_SURGERY = 'colorectalSurgery',
  CRITICAL_CARE_MEDICINE = 'criticalCareMedicine',
  DERMATOLOGY = 'dermatology',
  DEVELOPMENTAL_PEDIATRICS = 'developmentalPediatrics',
  DIAGNOSTIC_RADIOLOGY = 'diagnosticRadiology',
  ELECTROENCEPHALOGRAPHY = 'electroencephalography',
  EMERGENCY_MEDICINE = 'emergencyMedicine',
  ENDOCRINOLOGY_AND_METABOLISM = 'endocrinologyAndMetabolism',
  FAMILY_MEDICINE = 'familyMedicine',
  FORENSIC_PATHOLOGY = 'forensicPathology',
  FORENSIC_PSYCHIATRY = 'forensicPsychiatry',
  GASTROENTEROLOGY = 'gastroenterology',
  GENERAL_INTERNAL_MEDICINE = 'generalInternalMedicine',
  GENERAL_SURGERY = 'generalSurgery',
  GENERAL_SURGICAL_ONCOLOGY = 'generalSurgicalOncology',
  GERIATRIC_MEDICINE = 'geriatricMedicine',
  GERIATRIC_PSYCHIATRY = 'geriatricPsychiatry',
  GYNECOLOGIC_ONCOLOGY = 'gynecologicOncology',
  GYNECOLOGIC_REPRODUCTIVE_ENDOCRINOLOGY_AND_INFERTILITY = 'gynecologicReproductiveEndocrinologyAndInfertility',
  HEMATOLOGICAL_PATHOLOGY = 'hematologicalPathology',
  HEMATOLOGY = 'hematology',
  INFECTIOUS_DISEASES = 'infectiousDiseases',
  INTERNAL_MEDICINE = 'internalMedicine',
  MATERNAL_FETAL_MEDICINE = 'maternalFetalMedicine',
  MEDICAL_BIOCHEMISTRY = 'medicalBiochemistry',
  MEDICAL_GENETICS = 'medicalGenetics',
  MEDICAL_MICROBIOLOGY_AND_INFECTIOUS_DISEASES = 'medicalMicrobiologyAndInfectiousDiseases',
  MEDICAL_ONCOLOGY = 'medicalOncology',
  NEONATAL_PERINATAL_MEDICINE = 'neonatalPerinatalMedicine',
  NEPHROLOGY = 'nephrology',
  NEUROLOGY = 'neurology',
  NEUROPATHOLOGY = 'neuropathology',
  NEUROSURGERY = 'neurosurgery',
  NUCLEAR_MEDICINE = 'nuclearMedicine',
  OBSTETRICS_AND_GYNECOLOGY = 'obstetricsAndGynecology',
  OCCUPATIONAL_MEDICINE = 'occupationalMedicine',
  OPHTHALMOLOGY = 'ophthalmology',
  ORTHOPEDIC_SURGERY = 'orthopedicSurgery',
  OTOLARYNGOLOGY_HEAD_AND_NECK_SURGERY = 'otolaryngologyHeadAndNeckSurgery',
  PEDIATRIC_EMERGENCY_MEDICINE = 'pediatricEmergencyMedicine',
  PEDIATRIC_HEMATOLOGY_ONCOLOGY = 'pediatricHematologyOncology',
  PEDIATRIC_SURGERY = 'pediatricSurgery',
  PEDIATRICS = 'pediatrics',
  PHYSICAL_MEDICINE_AND_REHABILITATION = 'physicalMedicineAndRehabilitation',
  PLASTIC_SURGERY = 'plasticSurgery',
  PSYCHIATRY = 'psychiatry',
  PUBLIC_HEALTH = 'publicHealth',
  PUBLIC_HEALTH_AND_PREVENTIVE_MEDICINE = 'publicHealthAndPreventiveMedicine',
  RADIATION_ONCOLOGY = 'radiationOncology',
  RESPIROLOGY = 'respirology',
  RHEUMATOLOGY = 'rheumatology',
  THORACIC_SURGERY = 'thoracicSurgery',
  UROLOGY = 'urology',
  VASCULAR_SURGERY = 'vascularSurgery',
}
